import { getUserMail } from "../../services/util/getUserMail";
import { axiosBuySell, axiosUSD } from "../axios";

let userObj:any = {'email_id' : getUserMail()};

export function getHistoricalPlPercentageCF(startDate:any, endDate:any, asset:any,version:any, filterDropdownVersion:any)
{
    return axiosBuySell.post(`/commodity/get_pl_percent`,{
        "asset":asset,
        "startDate": startDate,
        "endDate":endDate,
        "version":version,
        "username": userObj?.email_id,
        "filterDropdownVersion" : filterDropdownVersion
    }).then((res:any)=>{
        return res.data;
    }).catch((err:any) => console.log(err))
}
export function getHistoricalCallsCF(startDate:any, endDate:any,asset:any,version:any, filterDropdownVersion:any)
{
    return axiosBuySell.post(`/commodity/get_calls`,
    {
        "asset":asset,
        "startDate": startDate,
        "endDate":endDate,
        "version":version,
        "username":userObj?.email_id,
        "filterDropdownVersion" : filterDropdownVersion
   }
    )
        .then((res:any)=>{
            return res.data
        }).catch((err:any) => console.log(err))
}
export function getHistoricalSRCF(startDate:any,endDate: any,asset:any,version:any, filterDropdownVersion:any)
{
    return axiosBuySell.post(`/commodity/get_sr`,
    {
        "asset":asset,
        "startDate": startDate,
        "endDate": endDate,
        "version":version,
        "username":userObj?.email_id,
        "filterDropdownVersion" : filterDropdownVersion
   }
    )
        .then((res:any)=>{
            return res.data
        }).catch((err:any) => console.log(err))
}
export function getHistoricalPlCF(startDate:any,endDate: any,asset:any,version:any, filterDropdownVersion:any)
{
    return axiosBuySell.post(`/commodity/get_pl`,
    {
        "asset":asset,
        "startDate": startDate,
        "endDate": endDate,
        "version":version,
        "username":userObj?.email_id,
        "filterDropdownVersion" : filterDropdownVersion
   }
    )
        .then((res:any)=>{
            return res.data
        }).catch((err:any) => console.log(err))
}
export async function getHistoricalTradesCF(startDate:any,endDate: any,asset:any,version:any, filterDropdownVersion:any)
{
    return await axiosBuySell.post(`/commodity/get_trades`,
    {
        "asset":asset,
        "startDate": startDate,
        "endDate": endDate,
        "version":version,
        "username":userObj?.email_id,
        "filterDropdownVersion" : filterDropdownVersion
   }
    )
        .then((res:any)=>{
            return res.data
        }).catch((err:any) => console.log(err))
}
export function getHistoricalParameterCF(id:any,asset:any,version:any,date:any)
{
    return axiosUSD.post(`/commodity/get_parameter`,
    {
        "asset":asset,
       "version": version,
       "date":date,
       "id":id ,
       "username":userObj?.email_id
   })
        .then((res:any)=>{
            return res.data
        }).catch((err:any)=>console.log(err))
}
export function getTargetSLCF(id:any,asset:any,version:any,date:any,trade_type:any)
{
    return axiosBuySell.post(`/commodity/get_target_stoploss`,
    {
        "date":date,
        "asset":asset,
        "version":version,
        "trade_type":trade_type,
        "id":id
    })
        .then((res:any)=>{
            return res.data
        }).catch((err:any) => console.log(err))
}
export function getMtmDrawdownCF(id:any,asset:any,date:any, version:any)
{
    return axiosBuySell.post(`/commodity/get_m2m_drawdown`,
    {
        "date":date,
        "asset":asset,
        "id":id,
        "version" : version
        // "username": userObj.email_id 
    } )
        .then((res:any)=>{
            return res?.data
        }).catch((err:any) => console.log(err))
}
